import { useState, useRef } from 'react';
import { useForm } from "react-hook-form";

import { ReactComponent as Cancel } from '../assets/cancel.svg';

import { Editor } from './Editor';

export default function MarketingAutomation ({value, saveMarketingAutomation, hideMarketingAutomation}) {

    const modules = {
	toolbar: [
	    [{ 'header': [1, 2, false] }],
	    ['bold', 'italic', 'underline','strike', 'blockquote'],
	    [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
	    ['link', 'image']
	],
    };

    const formats = [
	'header',
	'bold', 'italic', 'underline', 'strike', 'blockquote',
	'list', 'bullet', 'indent',
	'link', 'image'
    ];

    const texts_default = {
		completing_profile: {
			sms: {
				default_text: `Hi, #username#! Thank you for completing your profile. Here is your activation code - #activation_code#`,
			},
			email: {
				default_subject: `Thank you for completing your profile, #username#!`,
				default_html: `<p>Hi, #username#!</p><br>
					<p>Thank you for completing your profile. <br>To receive the points, input this code when prompted <h3>#activation_code#</h3><br/><br/>Feel free to reach out to me by responding to this email or to Misha (misha@fictiontribe.com) with any questions.</p>`,
			},
			hint: "Gratitude for completing profile.",
			templates: {username: 'John Smith', activation_code: '123456'},
		},
		unlocked: {
			sms: {
				default_text: `You have now unlocked additional activities in Lagoon. More points await! Explore your new activities, including augmented reality, by clicking this link #link#`
			},
			email: {
				default_subject: `Module two of Lagoon awaits you, #username#! `,
				default_html: `<p>Hi, #username#!</p><p>Congrats on completing Module 1 and unlocking three new activities!</p>				<p>&nbsp;</p>				<p>Explore your new activities, including augmented reality, by clicking this link on your phone #link# or scanning the QR code below on your mobile device.&nbsp;</p>				<p>&nbsp;</p><img width="250px" height="250px" style="margin-top: 20px; margin-bottom: 10px; max-width: 250px; width: 250px; height: 250px;" src="https://firebasestorage.googleapis.com/v0/b/lagoon-118b4.appspot.com/o/lagoon_live-qr2.png?alt=media&token=3c9fca39-2f2b-42f9-9f35-0791a5e95e64">				<p>&nbsp;</p>				<hr>				James Rice<br>				503-734-6474<br>				<a href="mailto:james@lagoonlive.com">james@lagoonlive.com</a>`,
			},
			hint: "Unlocked additional activities.",
			templates: {username: 'John Smith', link: 'https://app.lagoon.live/#/?unlock=9090909d9kz'},
		},
		confirming_phone: {
			hint: "Confirming the phone number.",
			templates: {code: '12345'},
			sms: {
			default_text: "Thank you for confirming the phone number. Your code is #code#",
			},
		}
    };

    var texts = JSON.parse(JSON.stringify(texts_default)); // Create a deep copy

    if (value) {
        for (let key in texts_default) {
            if (value[key]) { // Check if the key exists in value
                if (texts[key]['sms'] && value[key]['sms']) {
                    texts[key]['sms'] = { ...texts[key]['sms'], ...value[key]['sms'] };
                }
                if (texts[key]['email'] && value[key]['email']) {
                    texts[key]['email'] = { ...texts[key]['email'], ...value[key]['email'] };
                }
            }
        }
    }

    const {
	register,
	reset,
	setValue,
	handleSubmit,
	formState: { errors },
    } = useForm();

    const [message, changeMessage] = useState('');
    const setMessage = (text) => {
        changeMessage(text)
        setTimeout(() => {
            changeMessage();
        }, 3000);
    };

    const saveButton = (data) => {

	console.log(data);
        saveMarketingAutomation (data['texts']);
        hideMarketingAutomation ();
    }

    const changeEditor = (data) => {
    }


    return (

	<div className="right right_logo texts">
	    <div className="dashed-border">
		    <div className="title">
			<div>
			    <div className="name">Marketing Automation</div>
			</div>
			<div>
			    <div className="cancel" onClick={hideMarketingAutomation}>
				<Cancel/>
			    </div>
			</div>
		    </div>

		    <form className="">

			{!!texts &&

				Object.keys(texts).map( (key, index) =>


					<div key={index}>

{!!texts[key] && !!texts[key].hint && (

							<div className="subtitle">
								{texts[key].hint}
							</div>

							:
							null
						)}

{!!texts[key] && !!texts[key].sms && (

							<>
								<div className="hint">
									SMS
								</div>

								{/*
								<textarea
									{...register("texts["+key+"].sms.text")}
									placeholder={texts[key].sms.default_text}
									defaultValue={texts[key].sms.text ? texts[key].sms.text : texts[key].sms.default_text}
								>
								</textarea>
								*/}
<Editor
                    type="simple"
                    templates={texts[key].templates || {}}
                    value={(texts[key].sms && texts[key].sms.text) || texts[key].sms.default_text || ''}
                    register={register}
                    registerName={`texts[${key}].sms.text`}
                    setValue={setValue}
                    required="1"
                />




							</>

						)}

						{!!texts[key].email &&

							<>
								<div className="hint">
									Email subject
								</div>

								{/*
								{!!texts[key].templates ?

									<div className="templates">

										Use templates:

										{Object.keys(texts[key].templates).map((templates_key, templates_index) =>
											<div key={templates_index}>
												<span className="text_template">#{templates_key}#</span>
												{
													(templates_index+1) < Object.keys(texts[key].templates).length ? "" : null
												}
											</div>

										)}
									</div>

									:
									null
								}
								*/}

								{/*
								<textarea
									{...register("texts["+key+"].email.subject")}
									placeholder={texts[key].email.default_subject}
									defaultValue={texts[key].email.subject ? texts[key].email.subject : texts[key].email.default_subject}
								>
								</textarea>
								*/}


								<Editor
								    type="simple"
								    templates={texts[key].templates}
								    value={texts[key].email.subject ? texts[key].email.subject : texts[key].email.default_subject}
								    register={register}
								    registerName={"texts["+key+"].email.subject"}
								    setValue={setValue}
								    required="1"

								/>

								<div className="hint">
									Email
								</div>

								<Editor
								    templates={texts[key].templates}
								    value={texts[key].email.html ? texts[key].email.html : texts[key].email.default_html}
								    register={register}
								    registerName={"texts["+key+"].email.html"}
								    setValue={setValue}
								    required="1"

								/>

								{/*
								<ReactQuill
									modules={modules}
									formats={formats}
									{...register("texts["+key+"].email.html")}
									theme="snow" value={texts[key].email.html ? texts[key].email.html : texts[key].email.default_html} onChange={changeEditor}
								/>
								*/}




							</>

						}


					</div>
				)
			}

			<button type="submit" className="button check save" onClick={handleSubmit(saveButton)}>
		    Save
		</button>
		<div className="error">{ message }</div>

			    </form>

		    </div>

	    </div>

    )

}
